// @flow

export const foodModes = Object.freeze({
  Breakfast: 'Breakfast',
  Dinner: 'Dinner',
  Afternoon: 'Afternoon',
});

export type FoodMode = $Values<typeof foodModes>
